import type { PlanChatModelDto, PlanDto } from '@dbrain/shared';

/**
 * 16c.2 (B2cFiyatlar2, B2cTanitim2): what the public pages work out of the two packages' settings. Nothing here
 * holds a number of its own.
 */

/** D-375: the two packages offer exactly the same chat models (the same ones, in any order): one line in the strip */
export function sameChatModels(a: Pick<PlanDto, 'chatModels'>, b: Pick<PlanDto, 'chatModels'>): boolean {
  const ids = (plan: Pick<PlanDto, 'chatModels'>) => [...new Set(plan.chatModels.map((m) => m.id))].sort();
  const left = ids(a);
  const right = ids(b);
  return left.length === right.length && left.every((id, i) => id === right[i]);
}

/** "50 kat": how many times the free package's daily tokens Pro gives, when it is a whole number above one */
export function tokenTimes(free: Pick<PlanDto, 'dailyTokens'> | undefined, pro: Pick<PlanDto, 'dailyTokens'>): number | null {
  if (!free || free.dailyTokens <= 0) return null;
  const times = pro.dailyTokens / free.dailyTokens;
  return Number.isInteger(times) && times > 1 ? times : null;
}

/** The models a package lists on its card: its own beside the other package's (Pro's "Büyük, Orta, Hızlı dahil") */
export function ownModels(plan: Pick<PlanDto, 'chatModels'>, other: Pick<PlanDto, 'chatModels'> | undefined): PlanChatModelDto[] {
  return plan.chatModels.filter((m) => !other?.chatModels.some((o) => o.id === m.id));
}

/**
 * "Büyük, Orta, Hızlı": the names of Pro's own models with a shared last word ("model") left out, as the mockups
 * write them; names without one stay whole.
 */
export function shortNames(names: string[]): string {
  const words = names.map((name) => name.trim().split(/\s+/));
  const last = words[0]?.at(-1)?.toLocaleLowerCase('tr');
  const shared = names.length > 1 && last !== undefined && words.every((w) => w.length > 1 && w.at(-1)?.toLocaleLowerCase('tr') === last);
  return (shared ? words.map((w) => w.slice(0, -1).join(' ')) : names).join(', ');
}
